/** Block name. */
export const enum GQLEnumBlockNameEnum {
  actionBox = 'actionBox',
  coreEmbed = 'coreEmbed',
  coreGallery = 'coreGallery',
  coreHeading = 'coreHeading',
  coreHtml = 'coreHtml',
  coreImage = 'coreImage',
  coreList = 'coreList',
  coreListItem = 'coreListItem',
  coreParagraph = 'coreParagraph',
  corePullquote = 'corePullquote',
  coreQuote = 'coreQuote',
  coreSeparator = 'coreSeparator',
  cyclonePost = 'cyclonePost',
  featuredProduct = 'featuredProduct',
  featuredProducts = 'featuredProducts',
  highlight = 'highlight',
  homepageHeroLedes = 'homepageHeroLedes',
  imageCompare = 'imageCompare',
  imageSlider = 'imageSlider',
  legacyProduct = 'legacyProduct',
  legacyProductsTable = 'legacyProductsTable',
  link = 'link',
  methodologyAccordion = 'methodologyAccordion',
  newsletter = 'newsletter',
  postsInserter = 'postsInserter',
  product = 'product',
  productsTable = 'productsTable',
  rating = 'rating',
  relatedPosts = 'relatedPosts',
  startHere = 'startHere',
  startHereItem = 'startHereItem',
  subscriptionBenefits = 'subscriptionBenefits',
  subscriptionCollage = 'subscriptionCollage',
  subscriptionPricingPlan = 'subscriptionPricingPlan',
  supportingCastEmbed = 'supportingCastEmbed',
  table = 'table',
  tableOfContents = 'tableOfContents',
  video = 'video'
};

/** Block placement. */
export const enum GQLEnumBlockPlacementEnum {
  default = 'default',
  left = 'left',
  wide = 'wide'
};

/** Moderation state for user comments. Determines whether comments are publicly visible, pending approval, or marked as spam. */
export const enum GQLEnumCommentStatusEnum {
  /** Comments with the Approved status */
  APPROVE = 'APPROVE',
  /** Comments with the Unapproved status */
  HOLD = 'HOLD',
  /** Comments with the Spam status */
  SPAM = 'SPAM',
  /** Comments with the Trash status */
  TRASH = 'TRASH'
};

/** Predefined modes for comments. */
export const enum GQLEnumCommentsModeEnum {
  qa = 'qa',
  standard = 'standard'
};

/** Identifier types for retrieving specific content. Determines which property (global ID, database ID, URI) is used to locate content objects. */
export const enum GQLEnumContentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DATABASE_ID = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  ID = 'ID',
  /** Identify a resource by the URI. */
  URI = 'URI'
};

/** Available content entity types that can be queried or filtered. Identifies the primary content structures available in the system. */
export const enum GQLEnumContentTypeEnum {
  /** The Type of Content object */
  ATTACHMENT = 'ATTACHMENT',
  /** The Type of Content object */
  GRAPHQL_DOCUMENT = 'GRAPHQL_DOCUMENT',
  /** The Type of Content object */
  PAGE = 'PAGE',
  /** The Type of Content object */
  POST = 'POST'
};

/** Allowed Content Types of the Campaign taxonomy. */
export const enum GQLEnumContentTypesOfCampaignEnum {
  /** The Type of Content object */
  ATTACHMENT = 'ATTACHMENT',
  /** The Type of Content object */
  POST = 'POST'
};

/** Allowed Content Types of the GraphqlDocumentGroup taxonomy. */
export const enum GQLEnumContentTypesOfGraphqlDocumentGroupEnum {
  /** The Type of Content object */
  GRAPHQL_DOCUMENT = 'GRAPHQL_DOCUMENT'
};

/** Hero layout. */
export const enum GQLEnumHeroLayoutEnum {
  featured_image_lead_with_grid = 'featured_image_lead_with_grid',
  four_up = 'four_up',
  one_up = 'one_up',
  three_up = 'three_up',
  three_up_with_categories = 'three_up_with_categories',
  three_up_with_super_cats = 'three_up_with_super_cats',
  two_up = 'two_up',
  zero_up = 'zero_up'
};

/** Homepage hero ledes layout. */
export const enum GQLEnumHomepageHeroLedeLayoutEnum {
  six_up = 'six_up',
  three_up = 'three_up'
};

/** Images orientation. */
export const enum GQLEnumImagesOrientationEnum {
  horizontal = 'horizontal',
  original = 'original',
  vertical = 'vertical',
  wide = 'wide'
};

/** Filter fights by card type. */
export const enum GQLEnumMmaFightCardType {
  /** Return all fights. */
  ALL = 'ALL',
  /** Return only main card fights. */
  MAIN = 'MAIN',
  /** Return only undercard fights. */
  UNDER = 'UNDER'
};

/** Predefined image size variations. Represents the standard image dimensions available for media assets. */
export const enum GQLEnumMediaItemSizeEnum {
  /** Full-size image. */
  FULL = 'FULL',
  /** Large image preview suitable for detail views. (1024x1024) */
  LARGE = 'LARGE',
  /** Medium image preview typically suitable for listings and detail views. (300x300) */
  MEDIUM = 'MEDIUM',
  /** Medium-to-large image preview suitable for listings and detail views. (768x0) */
  MEDIUM_LARGE = 'MEDIUM_LARGE',
  /** Small image preview suitable for thumbnails and listings. (150x150) */
  THUMBNAIL = 'THUMBNAIL'
};

/** Publication status for media items. Controls whether media is publicly accessible, private, or in another state. */
export const enum GQLEnumMediaItemStatusEnum {
  /** Automatically created media that has not been finalized */
  AUTO_DRAFT = 'AUTO_DRAFT',
  /** Media that inherits its publication status from the parent content */
  INHERIT = 'INHERIT',
  /** Media visible only to users with appropriate permissions */
  PRIVATE = 'PRIVATE',
  /** Media marked for deletion but still recoverable */
  TRASH = 'TRASH'
};

/** Media file type classification based on MIME standards. Used to identify and filter media items by their format and content type. */
export const enum GQLEnumMimeTypeEnum {
  /** application/msword mime type. */
  APPLICATION_MSWORD = 'APPLICATION_MSWORD',
  /** application/pdf mime type. */
  APPLICATION_PDF = 'APPLICATION_PDF',
  /** application/vnd.apple.keynote mime type. */
  APPLICATION_VND_APPLE_KEYNOTE = 'APPLICATION_VND_APPLE_KEYNOTE',
  /** application/vnd.ms-excel mime type. */
  APPLICATION_VND_MS_EXCEL = 'APPLICATION_VND_MS_EXCEL',
  /** application/vnd.ms-excel.sheet.binary.macroEnabled.12 mime type. */
  APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12',
  /** application/vnd.ms-excel.sheet.macroEnabled.12 mime type. */
  APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12',
  /** application/vnd.ms-powerpoint mime type. */
  APPLICATION_VND_MS_POWERPOINT = 'APPLICATION_VND_MS_POWERPOINT',
  /** application/vnd.ms-powerpoint.presentation.macroEnabled.12 mime type. */
  APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12 = 'APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.slideshow.macroEnabled.12 mime type. */
  APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12',
  /** application/vnd.ms-word.document.macroEnabled.12 mime type. */
  APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12 = 'APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12',
  /** application/vnd.oasis.opendocument.text mime type. */
  APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT = 'APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT',
  /** application/vnd.openxmlformats-officedocument.presentationml.presentation mime type. */
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION',
  /** application/vnd.openxmlformats-officedocument.presentationml.slideshow mime type. */
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW',
  /** application/vnd.openxmlformats-officedocument.spreadsheetml.sheet mime type. */
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET',
  /** application/vnd.openxmlformats-officedocument.wordprocessingml.document mime type. */
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT',
  /** audio/flac mime type. */
  AUDIO_FLAC = 'AUDIO_FLAC',
  /** audio/midi mime type. */
  AUDIO_MIDI = 'AUDIO_MIDI',
  /** audio/mpeg mime type. */
  AUDIO_MPEG = 'AUDIO_MPEG',
  /** audio/ogg mime type. */
  AUDIO_OGG = 'AUDIO_OGG',
  /** audio/wav mime type. */
  AUDIO_WAV = 'AUDIO_WAV',
  /** image/avif mime type. */
  IMAGE_AVIF = 'IMAGE_AVIF',
  /** image/gif mime type. */
  IMAGE_GIF = 'IMAGE_GIF',
  /** image/jpeg mime type. */
  IMAGE_JPEG = 'IMAGE_JPEG',
  /** image/png mime type. */
  IMAGE_PNG = 'IMAGE_PNG',
  /** image/webp mime type. */
  IMAGE_WEBP = 'IMAGE_WEBP',
  /** video/3gpp mime type. */
  VIDEO_3GPP = 'VIDEO_3GPP',
  /** video/3gpp2 mime type. */
  VIDEO_3GPP2 = 'VIDEO_3GPP2',
  /** video/avi mime type. */
  VIDEO_AVI = 'VIDEO_AVI',
  /** video/mp4 mime type. */
  VIDEO_MP4 = 'VIDEO_MP4',
  /** video/mpeg mime type. */
  VIDEO_MPEG = 'VIDEO_MPEG',
  /** video/ogg mime type. */
  VIDEO_OGG = 'VIDEO_OGG',
  /** video/quicktime mime type. */
  VIDEO_QUICKTIME = 'VIDEO_QUICKTIME',
  /** video/webm mime type. */
  VIDEO_WEBM = 'VIDEO_WEBM'
};

/** Status of an MMA fight */
export const enum GQLEnumMmaFightStatus {
  /** Fight has been canceled */
  CANCELED = 'CANCELED',
  /** Fight has been completed */
  COMPLETED = 'COMPLETED',
  /** Fight is scheduled but has not occurred yet */
  UPCOMING = 'UPCOMING'
};

/** Menu location. */
export const enum GQLEnumNavMenuLocationEnum {
  FOOTER = 'FOOTER',
  MAIN = 'MAIN'
};

/** Sort direction for ordered results. Determines whether items are returned in ascending or descending order. */
export const enum GQLEnumOrderEnum {
  /** Results ordered from lowest to highest values (i.e. A-Z, oldest-newest) */
  ASC = 'ASC',
  /** Results ordered from highest to lowest values (i.e. Z-A, newest-oldest) */
  DESC = 'DESC'
};

/** Content field rendering options. Determines whether content fields are returned as raw data or with applied formatting and transformations. Default is RENDERED. */
export const enum GQLEnumPostObjectFieldFormatEnum {
  /** Unprocessed content exactly as stored in the database, requires appropriate permissions. */
  RAW = 'RAW',
  /** Content with all formatting and transformations applied, ready for display. */
  RENDERED = 'RENDERED'
};

/** Date field selectors for content filtering. Specifies which date attribute (creation date, modification date) should be used for date-based queries. */
export const enum GQLEnumPostObjectsConnectionDateColumnEnum {
  /** The date the comment was created in local time. */
  DATE = 'DATE',
  /** The most recent modification date of the comment. */
  MODIFIED = 'MODIFIED'
};

/** Content sorting attributes for post-type objects. Identifies which content property should be used to determine result order. */
export const enum GQLEnumPostObjectsConnectionOrderbyEnum {
  /** Ordering by content author (typically by author name). */
  AUTHOR = 'AUTHOR',
  /** Ordering by popularity based on number of comments. */
  COMMENT_COUNT = 'COMMENT_COUNT',
  /** Chronological ordering by publication date. */
  DATE = 'DATE',
  /** Maintain custom order of IDs exactly as specified in the query with the IN field. */
  IN = 'IN',
  /** Ordering by manually defined sort position. */
  MENU_ORDER = 'MENU_ORDER',
  /** Chronological ordering by modified date. */
  MODIFIED = 'MODIFIED',
  /** Maintain custom order of IDs exactly as specified in the query with the NAME_IN field. */
  NAME_IN = 'NAME_IN',
  /** Ordering by parent-child relationship in hierarchical content. */
  PARENT = 'PARENT',
  /** Alphabetical ordering by URL-friendly name. */
  SLUG = 'SLUG',
  /** Alphabetical ordering by content title */
  TITLE = 'TITLE'
};

/** Publishing status that controls the visibility and editorial state of content. Determines whether content is published, pending review, in draft state, or private. */
export const enum GQLEnumPostStatusEnum {
  /** Objects with the acf-disabled status */
  acfDisabled = 'acfDisabled',
  /** Objects with the archived status */
  archived = 'archived',
  /** Automatically saved content that has not been manually saved */
  autoDraft = 'autoDraft',
  /** Objects with the dp-rewrite-republish status */
  dpRewriteRepublish = 'dpRewriteRepublish',
  /** Content that is saved but not yet published or visible to the public */
  draft = 'draft',
  /** Objects with the future status */
  future = 'future',
  /** Content that inherits its status from a parent object */
  inherit = 'inherit',
  /** Content awaiting review before publication */
  pending = 'pending',
  /** Content only visible to authorized users with appropriate permissions */
  private = 'private',
  /** Content that is publicly visible to all visitors */
  publish = 'publish',
  /** Objects with the request-completed status */
  requestCompleted = 'requestCompleted',
  /** Objects with the request-confirmed status */
  requestConfirmed = 'requestConfirmed',
  /** Objects with the request-failed status */
  requestFailed = 'requestFailed',
  /** Objects with the request-pending status */
  requestPending = 'requestPending',
  /** Content marked for deletion but still recoverable */
  trash = 'trash'
};

/** Post (story/feature) templates. */
export const enum GQLEnumPostTemplateEnum {
  brandedFullWidth = 'brandedFullWidth',
  brandedPortrait = 'brandedPortrait',
  fullWidth = 'fullWidth',
  specialFeatureFullWidth = 'specialFeatureFullWidth',
  specialFeatureOverlay = 'specialFeatureOverlay',
  specialFeatureSquare = 'specialFeatureSquare',
  square = 'square'
};

/** Product block display variant. */
export const enum GQLEnumProductBlockVariantEnum {
  hypeDesk = 'hypeDesk',
  standard = 'standard'
};

/** Logical operators for filter conditions. Determines whether multiple filtering criteria should be combined with AND (all must match) or OR (any can match). */
export const enum GQLEnumRelationEnum {
  /** All conditions must match (more restrictive filtering) */
  AND = 'AND',
  /** Any condition can match (more inclusive filtering) */
  OR = 'OR'
};

/** Resource type. */
export const enum GQLEnumResourceTypeEnum {
  authorProfile = 'authorProfile',
  campaign = 'campaign',
  category = 'category',
  clientError = 'clientError',
  customStory = 'customStory',
  diningReport = 'diningReport',
  embedStory = 'embedStory',
  homepage = 'homepage',
  image = 'image',
  internalCategory = 'internalCategory',
  internalSuperCat = 'internalSuperCat',
  linkPost = 'linkPost',
  loopNav = 'loopNav',
  map = 'map',
  mmaEvent = 'mmaEvent',
  mmaFight = 'mmaFight',
  mmaFighter = 'mmaFighter',
  mmaPromotion = 'mmaPromotion',
  mmaWeightClass = 'mmaWeightClass',
  neighborhood = 'neighborhood',
  package = 'package',
  page = 'page',
  post = 'post',
  product = 'product',
  productBrand = 'productBrand',
  quickPost = 'quickPost',
  redirect = 'redirect',
  series = 'series',
  startHere = 'startHere',
  stream = 'stream',
  superCat = 'superCat',
  tag = 'tag',
  vault = 'vault',
  venue = 'venue',
  videoGame = 'videoGame',
  videoGamePlatform = 'videoGamePlatform',
  videoPost = 'videoPost',
  volumeVideo = 'volumeVideo'
};

/** Table of contents display type. */
export const enum GQLEnumTableOfContentDisplayEnum {
  compact = 'compact',
  none = 'none',
  standard = 'standard'
};

/** Available classification systems for organizing content. Identifies the different taxonomy types that can be used for content categorization. */
export const enum GQLEnumTaxonomyEnum {
  /** Taxonomy enum vm_campaign_term */
  CAMPAIGN = 'CAMPAIGN',
  /** Taxonomy enum category */
  CATEGORY = 'CATEGORY',
  /** Taxonomy enum graphql_document_group */
  GRAPHQLDOCUMENTGROUP = 'GRAPHQLDOCUMENTGROUP',
  /** Taxonomy enum post_format */
  POSTFORMAT = 'POSTFORMAT',
  /** Taxonomy enum post_tag */
  TAG = 'TAG'
};

/** The Type of Identifier used to fetch a single resource. Default is "ID". To be used along with the "id" field. */
export const enum GQLEnumTermNodeIdTypeEnum {
  /** The Database ID for the node */
  DATABASE_ID = 'DATABASE_ID',
  /** The hashed Global ID */
  ID = 'ID',
  /** The name of the node */
  NAME = 'NAME',
  /** Url friendly name of the node */
  SLUG = 'SLUG',
  /** The URI for the node */
  URI = 'URI'
};

/** Sorting attributes for taxonomy term collections. Determines which property of taxonomy terms is used for ordering results. */
export const enum GQLEnumTermObjectsConnectionOrderbyEnum {
  /** Ordering by number of associated content items. */
  COUNT = 'COUNT',
  /** Alphabetical ordering by term description text. */
  DESCRIPTION = 'DESCRIPTION',
  /** Alphabetical ordering by term name. */
  NAME = 'NAME',
  /** Alphabetical ordering by URL-friendly name. */
  SLUG = 'SLUG',
  /** Ordering by assigned term grouping value. */
  TERM_GROUP = 'TERM_GROUP',
  /** Ordering by internal identifier. */
  TERM_ID = 'TERM_ID',
  /** Ordering by manually defined sort position. */
  TERM_ORDER = 'TERM_ORDER'
};

/** Text alignment. */
export const enum GQLEnumTextAlignEnum {
  center = 'center',
  left = 'left',
  right = 'right'
};

/** MIME type supported by thumbnails. */
export const enum GQLEnumThumbnailMimeTypeEnum {
  imageGif = 'imageGif',
  imageJpg = 'imageJpg',
  imagePng = 'imagePng',
  imageSvgXml = 'imageSvgXml',
  imageWebp = 'imageWebp'
};

/** Predefined sizes of the thumbnails. */
export const enum GQLEnumThumbnailSizesEnum {
  horizontal = 'horizontal',
  horizontalZoom = 'horizontalZoom',
  original = 'original',
  social = 'social',
  square = 'square',
  squareZoom = 'squareZoom',
  vertical = 'vertical',
  widescreen = 'widescreen'
};

/** The player of a video. */
export const enum GQLEnumVideoPlayerEnum {
  chorus = 'chorus',
  youtube = 'youtube'
};
